import * as React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { useCommon } from 'src/domains/common/Common';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';
import { UniverseComponent } from 'src/domains/common/universes';

export const LogoutButton = observer('LogoutButton', () => {
    const common = useCommon();
    const { loginState } = AppPlayersState.get(common);
    return (
        <UniverseComponent>
            {(universeModule): React.ReactElement => (
                <Button
                    onClick={loginState.logOut}
                    size='xs'
                    version={universeModule.accountButtons.logoutButton}
                    dataTest='button-logout'
                >
                    <I18n
                        langKey='account.help-box.logout.label'
                        defaultText='Log Out'
                    />
                </Button>
            )}
        </UniverseComponent>
    );
});
